import { gql } from "@apollo/client";
import { organizationDetailsFragment, organizationPermissionsFragment } from "../fragments";

export const searchOrganization = gql`
    query searchOrganizations($query: String) {
        searchOrganizations(input: { query: $query }) {
            organizations {
                ...OrganizationDetails
                ...OrganizationPermissions
                appsManagementEnabled
                accountIds
            }
        }
    }
    ${organizationDetailsFragment}
    ${organizationPermissionsFragment}
`;
